import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  ViewChild
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AuthService} from '../../auth/AuthService';
import {ActivatedRoute, Router} from '@angular/router';
import {debounceTime, filter, first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Sort} from '@angular/material/sort';
import {PatientService} from '../../Services/patient.service';
import {ClientService} from '../../Services/client.service';
import {Subject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {parse, format, isValid} from 'date-fns';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {UserService} from '../../Services/UserService';
import {DatePipe} from '@angular/common';
import {HttpParams} from '@angular/common/http';


interface PatientPagination {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

interface filterParams {
  filterType: any;
  filterParam:any;
  startDate: any;
  endDate: any;
  wStartDate: any;
  wEndDate: any;
  planType: any;
  patientBenefitType: 'DENTAL' | 'MEDICAL' | 'BOTH';
  isMultipleFilter: boolean;
  userTimeZone: any;
  status: boolean | null;
  verification: any;
  sort: any;
  agent: number[] | null;
  payerIds: number[];
}

@Component({
  selector: 'pm-patient-registration',
  templateUrl: './patient-registration.component.html',
  styleUrls: ['./patient-registration.component.css']
})

export class PatientRegistrationComponent implements OnInit, AfterViewInit {

  tableData: any = [];
  assignArray: any = [];
  checked: boolean = false;
  agentArray: any = [];
  agent: any = null;
  totalRecord: any;
  // page:searchModel = new searchModel();
  pagination: PatientPagination = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };
  filter: filterParams = {
    filterType:'initial',
    filterParam:null,
    startDate: null,
    endDate: null,
    wStartDate: new Date(),
    wEndDate: new Date(),
    planType: 'PPO',
    patientBenefitType: 'BOTH',
    isMultipleFilter: true,
    userTimeZone: this.authService.getTimeZone(),
    status: true,
    verification: null,
    sort: null,
    agent: [] as number[],
    payerIds: [] as number[]
  };
  activeFilterType: string | null = null;
  activeFilterParams: any = null;
  sortDirection: 'asc' | 'desc' | null = null;
  sortField: string = '';
  searchString: any = null;
  searchPHolder: string = 'Search by name';
  button: string = 'Name';
  pBulkImport: FormGroup;
  files: File[] = [];
  isDragOver: boolean = false;
  fileImage: string | null = null; // Variable to hold the image URL
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  errorMessages: string[] = [];
  errorMessagePart: string | null = null;
  @ViewChild('fileDropRef') fileDropRef!: ElementRef;
  @ViewChild('searchBox') searchValue!: ElementRef;
  @ViewChild('bulkUpload') bulkUploadModal!: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
  @ViewChild('startDate', {static: true}) startDateInput: ElementRef;
  @ViewChild('endDate', {static: true}) endDateInput: ElementRef;
  @ViewChild('wstartDate', {static: true}) wstartDateInput: ElementRef;
  @ViewChild('wendDate', {static: true}) wendDateInput: ElementRef;
  searchText: string = '';
  search: string = '';
  assignmentAgentArray: any[] = [];
  filterAgentArray: any[] = [];
  private latestFilterAgentResults: any[] = [];
  payerArray: any[] = [];
  filterPayerArray: any[] = [];
  private latestPayerFilterResults: any[] = [];
  readonly payerInitialRenderLimit = 75;
  userId: any = null;
  userIds: any = [];
  agentId: any = null;
  meta: any;
  startDate: Date;
  endDate: Date;
  wstartDate: Date;
  wendDate: Date;
  minEndDate: Date | null = null; // Minimum date for End Date
  nameFilter: string;
  isDropdownOpen = false;
  isAgentSelectOpen = false;
  isPayerSelectOpen = false;
  status: string | null = null;
  toggleClicked: boolean = false;
  lStartDate: Date = new Date();
  lEndDate: Date = new Date();
  private clientSub: any;
  private currentClientId: number | null = null;
  private readonly workAllocationStatePrefix = 'patientWorkAllocationState:';
  private subject: Subject<string> = new Subject();

  constructor(private fb: FormBuilder,
              private patientService: PatientService,
              private clientService: ClientService,
              public authService: AuthService,
              private userServices: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private dialog: MatDialog,
              private datePipe: DatePipe,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone
              ) {
    this._setSearchSubscription();
  }

  ngOnInit(): void {
    this.currentClientId = this.authService.getClientId() || null;

    // Restore this client's last filters, page and sort before the first API call.
    this.loadPaginationState();
    this.getAgents();
    this.getPayers();
    this.fetchCurrentView();

    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (!clientId || clientId === this.currentClientId) {
        return;
      }

      // State is stored per client, so switching clients does not overwrite
      // the previous client's User Work Allocation view.
      this.currentClientId = clientId;
      this.resetTransientSelection();
      this.resetViewStateDefaults();
      this.loadPaginationState();
      this.getAgents();
      this.getPayers();
      this.fetchCurrentView();
    });
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageIndex = this.pagination.currentPage; // Restore page index
    }
  }

  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }

  private get workAllocationStateKey(): string {
    const clientId = this.currentClientId || this.authService.getClientId() || 'default';
    return `${this.workAllocationStatePrefix}${clientId}`;
  }

  private resetTransientSelection(): void {
    this.assignArray = [];
    this.checked = false;
    this.userId = null;
    this.isDropdownOpen = false;
    this.toggleClicked = false;
  }

  private resetViewStateDefaults(): void {
    this.pagination = {
      page: 1,
      size: 10,
      currentPage: 0
    };

    this.filter = {
      filterType: 'initial',
      filterParam: null,
      startDate: null,
      endDate: null,
      wStartDate: new Date(),
      wEndDate: new Date(),
      planType: 'PPO',
      patientBenefitType: 'BOTH',
      isMultipleFilter: true,
      userTimeZone: this.authService.getTimeZone(),
      status: true,
      verification: null,
      sort: null,
      agent: [] as number[],
      payerIds: [] as number[]
    };

    this.sortField = '';
    this.sortDirection = null;
    this.searchString = null;
    this.activeFilterType = null;
    this.activeFilterParams = null;
    this.startDate = null;
    this.endDate = null;
    this.wstartDate = null;
    this.wendDate = null;
  }

  private saveWorkAllocationState(): void {
    const state = {
      filter: this.filter,
      pagination: this.pagination,
      sortField: this.sortField || null,
      sortDirection: this.sortDirection || null,
      searchString: this.searchString?.trim() || null
    };

    sessionStorage.setItem(this.workAllocationStateKey, JSON.stringify(state));
  }

  private fetchCurrentView(): void {
    if (this.searchString?.trim()) {
      this.searchPatient();
    } else {
      this._fetchData();
    }
  }

  private normalizePatientBenefitType(value: any): 'DENTAL' | 'MEDICAL' | 'BOTH' {
    return value === 'DENTAL' || value === 'MEDICAL' ? value : 'BOTH';
  }

  private defaultWorkOrderRangeIfMissing(filter: any): { wStartDate: Date | null; wEndDate: Date | null } {
    const from = this.restoreDate(filter?.wStartDate);
    const to = this.restoreDate(filter?.wEndDate);
    // Previous persisted states had blank inputs while the API used today's date.
    // Migrate those states so the UI reflects the effective request.
    if (!from && !to) {
      const today = new Date();
      return { wStartDate: today, wEndDate: new Date(today) };
    }
    return { wStartDate: from, wEndDate: to };
  }

  private restoreDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    const restored = new Date(value);
    return isNaN(restored.getTime()) ? null : restored;
  }

  trackByTableId(index: number, item: any): any {
    return item?.id ?? index;
  }

  onAgentDropdownToggle(isOpen: boolean) {
    // Optional: handle open/close
    // console.log('Agent dropdown open:', isOpen);
  }
  onAgentSelectOpened() {
    this.isAgentSelectOpen = true;
  }

  onAgentSelectClosed() {
    this.isAgentSelectOpen = false;
  }

  getAssignmentAgentName(agentId: number | null): string {
  if (agentId === null || agentId === undefined) {
    return 'Select Agent';
  }

  const agent = this.agentArray.find(
    (item: any) => String(item.id) === String(agentId)
  );

  return agent?.fullName
    || `${agent?.firstName || ''} ${agent?.lastName || ''}`.trim()
    || 'Select Agent';
  }

  formatStartOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }

  formatEndOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(23, 59, 59, 999);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }



  setFilterType(type: string , filterParam?: any) {
    this.filter.filterType = type ? type : null;
    this.filter.filterParam = filterParam?filterParam :null;
  }


  applyVerificationFilter(verification: string) {
   this.filter.verification = verification
    // You can add the logic here to filter based on the verification status
  }

  resetFilter(event?: MouseEvent) {
    if (event) {
      event.stopPropagation(); // Prevent the click from propagating to the dropdown
    }

    this.isDropdownOpen = false;
    this.toggleClicked = false;

    // 🔄 Reset all filters and state
    this.startDate = null;
    this.endDate = null;
    this.activeFilterType = null;
    this.activeFilterParams = null;
    this.wstartDate = null;
    this.wendDate = null;
    this.nameFilter = '';
    this.tableData = [];
    this.userIds = [];
    this.agentId = null;
    this.filter.payerIds = [];

    // ✅ Reset filter to initial default state
    this.filter = {
      filterType: 'initial',
      filterParam:null,
      startDate: null,
      endDate: null,
      wStartDate: new Date(),
      wEndDate: new Date(),
      planType: 'PPO',
      patientBenefitType: 'BOTH',
      isMultipleFilter: true,
      userTimeZone: this.authService.getTimeZone(),
      status: true,
      verification: null,
      sort: null,
      agent: [] as number[],
      payerIds: [] as number[]
    };

    this.pagination = {
      page: 1,         // API uses 1-based index
      size: 10,        // Default page size
      currentPage: 0
    }

    // Reset only the filter/page state. Keep the current table sort unless
    // the user changes the sort from the header.
    this.saveWorkAllocationState();

    // 🔄 Refetch data with initial filter
    this._fetchData();
  }

  toggleFilter(type: string, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    switch (type) {
      case 'date':
        if (isChecked) {
          this.setFilterType('date');
        } else {
          this.filter.startDate = null;
          this.filter.endDate = null;
        }
        break;

      case 'wdate':
        if (isChecked) {
          this.setFilterType('wdate');
        } else {
          this.filter.wStartDate = null;
          this.filter.wEndDate = null;
        }
        break;

      case 'status':
        if (isChecked) {
          this.setFilterType(type);
        } else {
          // Disable that filter completely
          if (type === 'status') this.filter.status = null;
          this.filter.filterType = null;
        }
        break;

      case 'verification':
        if (isChecked) {
          this.setFilterType('verification');
        } else {
          this.filter.verification = null;
        }
        break;

      case 'agent':
        if (isChecked) {
          this.setFilterType('agent');
        } else {
          this.filter.agent = [];
        }
        break;
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.toggleClicked = this.isDropdownOpen;
  }

  applyFilters(): void {
    const appointmentDateIncomplete =
      (!!this.filter.startDate && !this.filter.endDate) ||
      (!this.filter.startDate && !!this.filter.endDate);

    const workOrderDateIncomplete =
      (!!this.filter.wStartDate && !this.filter.wEndDate) ||
      (!this.filter.wStartDate && !!this.filter.wEndDate);

    if (appointmentDateIncomplete || workOrderDateIncomplete) {
      swal.fire({
        icon: 'info',
        text: 'Please select both From and To dates for each date filter.',
        showConfirmButton: true
      });
      return;
    }

    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this.filter.filterType = 'multiple';
    this.saveWorkAllocationState();

    this._fetchData();
    this.isDropdownOpen = false;
    this.toggleClicked = false;
  }

  get activeFilterCount(): number {
    let count = 0;

    if (this.filter.startDate || this.filter.endDate) count++;
    if (this.filter.wStartDate || this.filter.wEndDate) count++;
    if (this.filter.status !== null && this.filter.status !== undefined) count++;
    if (this.filter.verification) count++;
    if (this.filter.agent?.length) count++;
    if (this.filter.payerIds?.length) count++;
    if (this.filter.patientBenefitType) count++;

    return count;
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement): void {
    if (this.isAgentSelectOpen || this.isPayerSelectOpen) {
      return;
    }
    // Only proceed if dropdown is open
    if (this.isDropdownOpen) {
      const clickedInsideDropdown = this.dropdownContainer?.nativeElement.contains(targetElement);
      const clickedInsideDatepicker =
          this.startDateInput?.nativeElement.contains(targetElement) ||
          this.endDateInput?.nativeElement.contains(targetElement) ||
          this.wendDateInput?.nativeElement.contains(targetElement) ||
          this.wstartDateInput?.nativeElement.contains(targetElement);
      const clickedInsideCalendar = !!targetElement.closest('.bs-datepicker');

      // If click is outside everything (dropdown + datepickers)
      if (!clickedInsideDropdown && !clickedInsideDatepicker && !clickedInsideCalendar) {
        this.isDropdownOpen = false;
        this.toggleClicked = false; // 🔹 keep toggle state in sync

        // Reset filters only if none are active
        if (!this.filter.filterType) {
          this.startDate = null;
          this.endDate = null;
          this.wstartDate = null;
          this.wendDate = null;
          this.resetFilter();
        }
      }
    }
  }


  onAssignmentFilteredReturn(filteredArray: any[]): void {
    this.assignmentAgentArray = [...(filteredArray || [])];
  }

  onFilterAgentFilteredReturn(filteredArray: any[]): void {
    // mat-select-filter rebuilds the option list while searching. In a multiple
    // select that can destroy an already-selected mat-option. Keep selected
    // agents rendered so previous selections survive subsequent searches.
    this.latestFilterAgentResults = [...(filteredArray || [])];
    this.rebuildFilterAgentOptions();
  }

  onFilterAgentSelectionChange(): void {
    this.filter.agent = Array.from(new Set(this.filter.agent || []));
    this.rebuildFilterAgentOptions();
  }

  private rebuildFilterAgentOptions(): void {
    const selectedIds = new Set((this.filter.agent || []).map(id => String(id)));
    const selectedAgents = this.agentArray.filter((agent: any) =>
      selectedIds.has(String(agent.id))
    );

    const uniqueAgents = new Map<string, any>();
    [...selectedAgents, ...this.latestFilterAgentResults].forEach((agent: any) => {
      if (agent?.id !== null && agent?.id !== undefined) {
        uniqueAgents.set(String(agent.id), agent);
      }
    });

    this.filterAgentArray = Array.from(uniqueAgents.values());
  }

  getAgentDisplayName(agentId: number): string {
    const agent = this.agentArray.find((item: any) => String(item.id) === String(agentId));
    return agent?.fullName || 'Selected agent';
  }

  trackByAgentId(index: number, agent: any): any {
    return agent?.id ?? index;
  }

  getAgents() {
    let params = {
      isWorkOrderUser: true,
      clientId: this.authService.getClientId()
    };
    this.patientService.getAgents(params).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.agentArray = response;
          // Add `fullName` property to each agent in `agentArray`
          this.agentArray = this.agentArray.map(agent => ({
            ...agent,
            fullName: `${agent.firstName} ${agent.lastName}`
          }));

          // Keep assignment and filter dropdowns independent.
          this.assignmentAgentArray = [...this.agentArray];
          this.latestFilterAgentResults = [...this.agentArray];
          this.rebuildFilterAgentOptions();
          /* this.filterAgentArray = this.agentArray.filter(agent =>
               `${agent.firstName} ${agent.lastName}`
                   .toLowerCase()
                   .includes(this.searchText.toLowerCase())
           );*/

        }
      });
  }

  getPayers(): void {
    const params = {
      isPayerNameAndId: true,
      clientId: this.authService.getClientId() || null
    };

    this.patientService.getPayer(params).pipe(first()).subscribe(
      (response: any) => {
        this.payerArray = Array.isArray(response) ? response : [];
        this.payerArray.sort((a: any, b: any) =>
          String(a?.name || '').localeCompare(String(b?.name || ''))
        );
        this.latestPayerFilterResults = [];
        this.rebuildPayerOptions();
      },
      () => {
        this.payerArray = [];
        this.latestPayerFilterResults = [];
        this.filterPayerArray = [];
      }
    );
  }

  onPayerFilteredReturn(filteredArray: any[]): void {
    this.latestPayerFilterResults = [...(filteredArray || [])];
    this.rebuildPayerOptions(true);
  }

  onPayerSelectionChange(): void {
    this.filter.payerIds = Array.from(new Set(this.filter.payerIds || []));
    this.rebuildPayerOptions();
  }

  private rebuildPayerOptions(searching = false): void {
    const selectedIds = new Set((this.filter.payerIds || []).map(id => String(id)));
    const selectedPayers = this.payerArray.filter((payer: any) => selectedIds.has(String(payer.id)));
    const source = searching
      ? this.latestPayerFilterResults.slice(0, this.payerInitialRenderLimit)
      : this.payerArray.slice(0, this.payerInitialRenderLimit);
    const unique = new Map<string, any>();
    [...selectedPayers, ...source].forEach((payer: any) => {
      if (payer?.id !== null && payer?.id !== undefined) unique.set(String(payer.id), payer);
    });
    this.filterPayerArray = Array.from(unique.values());
  }

  trackByPayerId(index: number, payer: any): any {
    return payer?.id ?? index;
  }

  // clear the search in the dropdown select search input
  dropdownSearchClear(event: any) {
    event.target.value = null;
    setTimeout(() => {
      this.assignmentAgentArray = [...this.agentArray];
      this.latestFilterAgentResults = [...this.agentArray];
      this.rebuildFilterAgentOptions();
    }, 300);
  }

  onKeyUp(searchTextValue: any): void {
    this.subject.next(searchTextValue);
  }

  assign(id?: any) {
    if (id === 'All') {
      if (this.checked) {
        // Uncheck all items
        this.assignArray = []; // Clear assignArray
        this.tableData.forEach(item => {
          item.assigned = false; // Set assigned to false for all
          delete item.assignedF; // Remove the assignedF property
        });
        this.checked = false;
      } else {
        // Assign all items
        this.assignArray = this.tableData.map(item => item.id); // Update assignArray with all IDs
        this.tableData.forEach(item => {
          item.assigned = true; // Set assigned to true for all
          item.assignedF = true; // Add assignedF property
        });
        this.checked = true;
      }
    } else {
      const index = this.assignArray.indexOf(id);
      if (index === -1) {
        // Add ID if it's not in assignArray and set assigned to true
        this.assignArray.push(id);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = true;
          item.assignedF = true; // Add assignedF property to the specific item
        }
      } else {
        // Remove ID if it's already in assignArray
        this.assignArray.splice(index, 1);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = false;
          delete item.assignedF; // Remove the assignedF property from the specific item
        }
      }

      // Set checked to true only if all tableData IDs are in assignArray
      this.checked = this.tableData.every(item => this.assignArray.includes(item.id));
    }
  }

  assignAgent(isAssigned?: boolean) {
    if (this.assignArray.length !== 0) {
      // Conditionally create the params object
      let params: any = {};
      if (isAssigned) {
        params.userId = this.userId;
      }
      params.isAssigned = isAssigned;
      params.planType = 'PPO';

      let reqData = this.assignArray;
      this.patientService.assignPatient(reqData, params).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this.refreshPatientListAfterAssignment();
            // this._fetchData();
            swal.fire({
              icon: 'success',
              text: 'Done',
              showConfirmButton: false,
              timer: 3000
            });
            this.userId = null;
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    } else {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: 'Please select at least one patient',
        showConfirmButton: false,
        timer: 5000
      });
      this.userId = null;
    }
  }

  refreshPatientListAfterAssignment() {
    if (this.activeFilterType === 'wdate' && this.activeFilterParams) {
      this.activeFilterParams.page = this.pagination.page;
      this.activeFilterParams.size = this.pagination.size;

      this.patientService.filterDateWOD(this.activeFilterParams).pipe(first()).subscribe((response: any) => {
        this.tableData = response.content;
        this.totalRecord = response.totalElements;

        if (this.paginator) {
          this.paginator.pageIndex = this.pagination.currentPage;
        }
      });
    } else {
      this.fetchCurrentView();
    }
  }

  changeStatus(status: boolean) {
    if (this.assignArray.length !== 0) {
      let params: any = {
        isActive: status
      };
      let reqData = this.assignArray;
      this.patientService.assignPatient(reqData, params).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this.fetchCurrentView();
            swal.fire({
              icon: 'success',
              text: 'Done',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    } else {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: 'Please select at least one patient',
        showConfirmButton: false,
        timer: 5000
      });
    }

  }

  onSearch(): void {
    let inputValue = this.searchValue?.nativeElement?.value ?? this.searchString ?? '';
    inputValue = decodeURIComponent(String(inputValue)).trim();

    // A new search always starts on the first result page.
    this.pagination.currentPage = 0;
    this.pagination.page = 1;

    if (inputValue) {
      const isDateLike = this.isDateLike(inputValue);

      if (isDateLike) {
        this.formatDateString(inputValue);
      } else {
        this.searchString = inputValue;
        this.saveWorkAllocationState();
        this.searchPatient();
      }
    } else {
      this.searchString = null;
      this.saveWorkAllocationState();
      this._fetchData();
    }
  }

  handleKeyUp(event: KeyboardEvent): void {
    const value = (event.target as HTMLInputElement).value;

    if (event.key === 'Enter') {
      this.onSearch();
      return;
    }

    // Mirror the input so the same search text can be restored when returning.
    this.searchString = value;
    this.subject.next(value);
  }

  clearSearch(input: HTMLInputElement): void {
    input.value = '';
    this.searchString = null;
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this.saveWorkAllocationState();
    this._fetchData();
  }



// Helper function to check if a string looks like a date
  isDateLike(input: string): boolean {
    // Regular expression to check for common date patterns
    const datePattern = /^(\d{1,2}[-\/]\d{1,2}[-\/]\d{2,4})|(\d{4}[-\/]\d{1,2}[-\/]\d{1,2})|([A-Za-z]+\s\d{1,2},\s\d{4})$/;

    // Test the input against the date pattern
    return datePattern.test(input);
  }

  formatDateString(inputDate: string) {
    // Define possible date formats to parse the input date
    const formats = [
      'MM/dd/yyyy',
      'dd/MM/yyyy',
      'yyyy/MM/dd',
      'yyyy-MM-dd',
      'dd-MM-yyyy',
      'MM-dd-yyyy',
      'MMMM dd, yyyy',    // e.g., "October 15, 2024"
      'yyyy/MM/dd HH:mm',  // e.g., "2024/10/15 14:30"
      'MM/dd/yyyy HH:mm',  // e.g., "10/15/2024 14:30"
      'dd-MM-yyyy HH:mm',  // e.g., "15-10-2024 14:30"
    ];

    let parsedDate: Date | null = null;

    // Try parsing the input date with each format
    for (const formatStr of formats) {
      parsedDate = parse(inputDate, formatStr, new Date());
      if (isValid(parsedDate)) {
        break;  // Stop if a valid date is found
      }
    }

    // If a valid date was parsed, format it to 'MM/dd/yyyy'
    if (parsedDate && isValid(parsedDate)) {
      const formattedDate = format(parsedDate, 'MM/dd/yyyy');
      this.searchString = formattedDate; // Set the formatted date as the search string
      this.saveWorkAllocationState();

      // Call the search function with the formatted date
      this.searchPatient();
    }
    // If no valid date is found, simply do nothing (no error message shown)
  }

  private updateTable(response: any) {
    this.ngZone.run(() => {
      this.tableData = [...(response?.content || response || [])];
      this.totalRecord = response?.totalElements || 0;
      // this.totalPagesArray = Array.from(
      //   { length: response?.totalPages || 0 },
      //   (_, i) => i + 1
      // );

      if (this.paginator) {
        this.paginator.pageIndex = this.pagination.currentPage;
      }

      this.cdr.detectChanges();
    });
  }

  searchPatient(): void {
    this.assignArray = [];
    this.checked = false;

    const search: { [key: string]: any } = {
      page: this.pagination.page,
      size: this.pagination.size,
      clientId: this.authService.getClientId() || null,
      planType: 'PPO',
      duplicate: false
    };

    const value = this.searchString?.trim();
    if (value) {
      search.searchString = value;
    }

    if (this.sortField && this.sortDirection) {
      search.sort = `${this.sortField},${this.sortDirection}`;
    }

    this.saveWorkAllocationState();

    this.patientService.searchPatient(search).pipe(first()).subscribe(
      (response: any) => {
        if (response !== undefined) {
          this.updateTable(response);
        }
      },
      (error) => {
        this.tableData = [];
        this.totalRecord = 0;
        this.cdr.detectChanges();

        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error?.error?.message || 'Something went wrong!',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }

  // Get Client data
  _fetchData(type?: any) {
    this.assignArray = [];
    this.checked = false;

    /*const filterType = this.filterType ? type ?? this.selectedType : undefined;*/
    let filterType = this.filter.filterType;
    let params: { [key: string]: any } = {
      page: this.pagination.page,
      size: this.pagination.size,
      clientId: this.authService.getClientId() || null,
      planType: this.filter.planType,
      patientBenefitType: this.normalizePatientBenefitType(this.filter.patientBenefitType),
      isMultipleFilter:this.filter.isMultipleFilter,
      userTimeZone:this.filter.userTimeZone,
      woStartDate : this.lStartDate ? this.formatStartOfDay(this.lStartDate) : null,
      woEndDate : this.lEndDate ? this.formatEndOfDay(this.lEndDate) : null,
      duplicate: false
    };

    // ✅ Add date params only on initial load

    if (this.filter.startDate && this.filter.endDate) {
      /*this.filter.startDate = this.startDate ? this.datePipe.transform(this.startDate, 'MM-dd-yyyy') : null;
      this.filter.endDate = this.endDate ? this.datePipe.transform(this.endDate, 'MM-dd-yyyy') : null;*/
      params.apStartDate =  this.filter.startDate ? this.formatStartOfDay(this.filter.startDate): null;
      params.apEndDate =  this.filter.endDate ? this.formatEndOfDay(this.filter.endDate) : null;


    }
    if (this.filter.wStartDate && this.filter.wEndDate) {
      /*this.filter.wStartDate = this.wstartDate ? this.formatStartOfDay(this.wstartDate) : null;
      this.filter.wEndDate = this.wendDate ? this.formatEndOfDay(this.wendDate) : null;*/
    /*  this.filter.isRegistrationStartDateEndDate = true;
      this.filter.userTimeZone = this.authService.getTimeZone();*/

      params.woStartDate = this.filter.wStartDate ? this.formatStartOfDay(this.filter.wStartDate): null;
      params.woEndDate = this.filter.wEndDate ? this.formatEndOfDay(this.filter.wEndDate): null;
      /*params.isRegistrationStartDateEndDate = this.filter.isRegistrationStartDateEndDate;
      params.userTimeZone = this.authService.getTimeZone();*/


    }


    // Sort
    if (this.sortField && this.sortDirection) {
      this.filter.sort = `${this.sortField},${this.sortDirection}`;

      params.sort = (this.sortField && this.sortDirection)
        ? `${this.sortField},${this.sortDirection}`
        : (this.filter?.sort || null);
    }

    // Filter logic
    if (filterType === 1) {
      if (this.searchString?.trim()) {
        params.searchString = this.searchString;
      }
    }

    if (this.filter.status !== null) {
        params.status = this.filter.status;
    }


    // ✅ Verification Filter
    if (this.filter.verification) {
        params.verification = this.filter.verification;
    }

    if (this.filter.agent && this.filter.agent.length > 0) {
      params.userIds = this.filter.agent;
    }


    // Clean undefined
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) {
        delete params[key];
      }
    });

    // Persist the complete view state before every request so returning to
    // this route restores the same filters, page and sorting.
    this.saveWorkAllocationState();

    // Build HttpParams explicitly so array filters are sent as repeated query keys.
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined && !Array.isArray(value)) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    (this.filter.agent || []).forEach(userId => {
      httpParams = httpParams.append('userIds', String(userId));
    });
    (this.filter.payerIds || []).forEach(payerId => {
      httpParams = httpParams.append('payerIds', String(payerId));
    });

    this.patientService.filterPatient(httpParams).pipe(first()).subscribe(
      (response: any) => {
        this.updateTable(response);
      },
      (error) => {
        this.tableData = [];
        this.totalRecord = 0;
        this.cdr.detectChanges();

        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message || '',
          showConfirmButton: false,
          timer: 5000
        });

        this.isDropdownOpen = false;
      }
    );
  }
  
  formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
}
  openModal(): void {
    this.errorMessages = [];
    this.errorMessagePart = null;

    const modalElement = this.bulkUploadModal.nativeElement;
    modalElement.style.display = 'flex';
    modalElement.classList.add('show');
  }

  closeModal(): void {
    this.errorMessages = [];
    this.errorMessagePart = null;
    this.files = [];
    this.fileImage = null;
    this.isDragOver = false;

    const modalElement = this.bulkUploadModal.nativeElement;
    modalElement.style.display = 'none';
    modalElement.classList.remove('show');
  }

  upload() {
    // Your upload logic here
    console.log('Uploading...');
  }

  onFilesSelected(event: any): void {
    const selectedFiles: FileList | null = event?.target?.files || null;
    this.errorMessages = [];
    this.errorMessagePart = null;

    this.files = selectedFiles?.length
      ? [selectedFiles.item(0) as File]
      : [];
  }

  formatFileSize(bytes: number): string {
    if (!bytes) return '0 KB';

    const units = ['B', 'KB', 'MB', 'GB'];
    const unitIndex = Math.min(
      Math.floor(Math.log(bytes) / Math.log(1024)),
      units.length - 1
    );
    const value = bytes / Math.pow(1024, unitIndex);

    return `${value >= 10 || unitIndex === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[unitIndex]}`;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    this.errorMessages = [];
    this.errorMessagePart = null;

    const droppedFiles = event.dataTransfer?.files;
    if (droppedFiles?.length) {
      const firstFile = droppedFiles.item(0);
      this.files = firstFile ? [firstFile] : [];
    }
  }

  uploadFiles(): void {
  if (this.files.length) {
    const formData = new FormData();

    const params = {
      clientId: this.authService.getClientId()
    };

    for (const file of this.files) {
      formData.append('file', file, file.name);
    }

    this.patientService
      .patientBulkUpload(formData, params)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response) {
            this._fetchData();
            this.closeModal();

            swal.fire({
              icon: 'success',
              text: 'Uploaded successfully.',
              html: this.buildUploadSummaryHtml(response),
              showConfirmButton: true,
              confirmButtonText: 'Close',
              showCloseButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              focusConfirm: false
            });
          } else {
            this.ngZone.run(() => {
              this.handleErrorResponse(response);
              this.cdr.detectChanges();
            });
          }
        },
        (error) => {
          this.ngZone.run(() => {
            this.handleErrorResponse(error.error);
            this.cdr.detectChanges();
          });
        }
      );
  }
  }

  private buildUploadSummaryHtml(res: any): string {
  const dup = res?.duplicate ?? {};
  const normal = res?.normal ?? {};

  const dupPPO = dup?.PPO ?? 0;
  const dupHMO = dup?.HMO ?? 0;

  const normalPPO = normal?.PPO ?? 0;
  const normalHMO = normal?.HMO ?? 0;

  const total = res?.total ?? 0;
  const duplicateTotal = res?.duplicateTotal ?? 0;
  const normalTotal = res?.normalTotal ?? 0;

  return `
    <div style="text-align:left">
      <div style="font-weight:600;margin-bottom:8px;">Upload Summary</div>

      <div style="margin:10px 0 6px;font-weight:600;">Duplicates</div>
      <table style="width:100%;border-collapse:collapse;">
        <tr>
          <td style="padding:6px 0;">PPO</td>
          <td style="padding:6px 0;text-align:right;font-weight:600;">${dupPPO}</td>
        </tr>
        <tr>
          <td style="padding:6px 0;">HMO</td>
          <td style="padding:6px 0;text-align:right;font-weight:600;">${dupHMO}</td>
        </tr>
      </table>

      <div style="margin:14px 0 6px;font-weight:600;">Normal (Uploaded)</div>
      <table style="width:100%;border-collapse:collapse;">
        <tr>
          <td style="padding:6px 0;">PPO</td>
          <td style="padding:6px 0;text-align:right;font-weight:600;">${normalPPO}</td>
        </tr>
        <tr>
          <td style="padding:6px 0;">HMO</td>
          <td style="padding:6px 0;text-align:right;font-weight:600;">${normalHMO}</td>
        </tr>
      </table>

      <hr style="margin:14px 0;" />

      <table style="width:100%;border-collapse:collapse;">
        <tr>
          <td style="padding:6px 0;">Total</td>
          <td style="padding:6px 0;text-align:right;font-weight:700;">${total}</td>
        </tr>
        <tr>
          <td style="padding:6px 0;">Duplicate Total</td>
          <td style="padding:6px 0;text-align:right;font-weight:700;">${duplicateTotal}</td>
        </tr>
        <tr>
          <td style="padding:6px 0;">Normal Total</td>
          <td style="padding:6px 0;text-align:right;font-weight:700;">${normalTotal}</td>
        </tr>
      </table>
    </div>
  `;
  }

  handleErrorResponse(error: any): void {
    this.errorMessages = [];
    this.errorMessagePart = null;

    const errorMessage = error?.message;
    const errorArray = error?.errors;

    // Case 1: Error with 'errors' array (structured validation errors)
    if (errorArray && Array.isArray(errorArray)) {
      this.errorMessagePart = errorMessage || 'Validation errors occurred';
      this.errorMessages = errorArray.map((e: any) => e.message || 'Unknown validation error');
    }
    // Case 2: Error message with "Details:"
    else if (errorMessage && errorMessage.includes('Details:')) {
      const {messagePart, detailsPart} = this.extractErrorDetails(errorMessage);
      this.errorMessagePart = messagePart;
      this.errorMessages = detailsPart;
    }
    // Fallback: Just a plain message
    else if (errorMessage) {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Fallback : string
    else if (typeof errorMessage === 'string') {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Last fallback
    else {
      this.errorMessagePart = 'An error occurred';
      this.errorMessages = [];
    }
  }

  extractErrorDetails(message: string): { messagePart: string, detailsPart: string[] } {
    const detailsStart = message.indexOf('Details:');

    if (detailsStart === -1) {
      return {messagePart: message.trim(), detailsPart: []};
    }

    // Split the main message and the detailed part
    const messagePart = message.substring(0, detailsStart).trim();
    const detailsString = message.substring(detailsStart + 8).trim();

    const detailsPart: string[] = [];

    // Match all nested brackets: [row: 1, ...], [row: 2, ...]
    const nestedDetailMatches = detailsString.match(/\[(.*?)\]/g); // Match all [ ... ] groups

    if (nestedDetailMatches) {
      nestedDetailMatches.forEach(detail => {
        const cleanDetail = detail
          .replace(/^\[|\]$/g, '') // remove outer brackets
          .trim();
        if (cleanDetail) {
          detailsPart.push(cleanDetail);
        }
      });
    } else {
      // Fallback if no brackets are found: split by comma
      detailsPart.push(...detailsString.split(',').map(d => d.trim()));
    }

    return {messagePart, detailsPart};
  }

  removeImage(): void {
    this.errorMessages = [];
    this.errorMessagePart = null;
    this.files = [];
    this.fileImage = null;

    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
  }

  // pagination changes
  pageChange(event: PageEvent): void {
    const pageSizeChanged = this.pagination.size !== event.pageSize;

    // Page-size changes can leave the paginator pointing to a page that no
    // longer exists. Start again from the first page when size changes.
    this.pagination.size = event.pageSize;
    this.pagination.currentPage = pageSizeChanged ? 0 : event.pageIndex;
    this.pagination.page = this.pagination.currentPage + 1;

    if (pageSizeChanged && this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.saveWorkAllocationState();

    // Preserve the active search endpoint during pagination.
    this.fetchCurrentView();
  }

  loadPaginationState(): void {
    const storedState = sessionStorage.getItem(this.workAllocationStateKey);

    if (storedState) {
      try {
        const state = JSON.parse(storedState);

        if (state?.pagination) {
          this.pagination = {
            page: Number(state.pagination.page) || 1,
            size: Number(state.pagination.size) || 10,
            currentPage: Number(state.pagination.currentPage) || 0
          };
        } else {
          this.pagination = {page: 1, size: 10, currentPage: 0};
        }

        if (state?.filter) {
          this.filter = {
            ...this.filter,
            ...state.filter,
            startDate: this.restoreDate(state.filter.startDate),
            endDate: this.restoreDate(state.filter.endDate),
            ...this.defaultWorkOrderRangeIfMissing(state.filter),
            patientBenefitType: this.normalizePatientBenefitType(state.filter.patientBenefitType),
            agent: Array.isArray(state.filter.agent) ? state.filter.agent : [],
            payerIds: Array.isArray(state.filter.payerIds) ? state.filter.payerIds.map(Number) : []
          };
        }

        this.sortField = state?.sortField || '';
        this.sortDirection =
          state?.sortDirection === 'asc' || state?.sortDirection === 'desc'
            ? state.sortDirection
            : null;

        this.searchString = typeof state?.searchString === 'string'
          ? state.searchString
          : null;

        return;
      } catch (e) {
        console.warn('Unable to restore User Work Allocation state.', e);
        sessionStorage.removeItem(this.workAllocationStateKey);
      }
    }

    // Backward-compatible migration from the old separate storage keys.
    const storedData = sessionStorage.getItem('patientPagination');
    const storedFilter = sessionStorage.getItem('patientFilters');

    if (storedData) {
      try {
        this.pagination = JSON.parse(storedData);
      } catch (e) {
        sessionStorage.removeItem('patientPagination');
      }
    }

    if (storedFilter) {
      try {
        const legacyFilter = JSON.parse(storedFilter);
        this.filter = {
          ...this.filter,
          ...legacyFilter,
          startDate: this.restoreDate(legacyFilter.startDate),
          endDate: this.restoreDate(legacyFilter.endDate),
          ...this.defaultWorkOrderRangeIfMissing(legacyFilter),
          patientBenefitType: this.normalizePatientBenefitType(legacyFilter.patientBenefitType),
          agent: Array.isArray(legacyFilter.agent) ? legacyFilter.agent : [],
          payerIds: Array.isArray(legacyFilter.payerIds) ? legacyFilter.payerIds.map(Number) : []
        };

        if (legacyFilter.sort && typeof legacyFilter.sort === 'string') {
          const [field, direction] = legacyFilter.sort.split(',');
          this.sortField = field || '';
          this.sortDirection = direction === 'asc' || direction === 'desc' ? direction : null;
        }
      } catch (e) {
        sessionStorage.removeItem('patientFilters');
      }
    }

    this.saveWorkAllocationState();
    sessionStorage.removeItem('patientPagination');
    sessionStorage.removeItem('patientFilters');
  }

  sortData(sort: Sort): void {
    this.sortField = sort.direction ? sort.active : '';
    this.sortDirection = sort.direction === '' ? null : sort.direction;
    this.filter.sort = this.sortField && this.sortDirection
      ? `${this.sortField},${this.sortDirection}`
      : null;

    this.saveWorkAllocationState();

    this.fetchCurrentView();
  }

  logout(): void {
    // Clear all persisted User Work Allocation views on logout.
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(this.workAllocationStatePrefix))
      .forEach(key => sessionStorage.removeItem(key));

    sessionStorage.removeItem('patientPagination');
    sessionStorage.removeItem('patientFilters');
    this.authService.logout();
  }


  // ngOnDestroy(): void {
  //     // Clear session storage when the component is destroyed
  //     // sessionStorage.removeItem('patientPagination');
  // }

  private _setSearchSubscription(): void {
    this.subject.pipe(
      debounceTime(200)
    ).subscribe((searchValue: any) => {
      if (this.searchValue.nativeElement.value === '') {
        this.onSearch();
      }
    });
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
